<mat-form-field appearance="fill" class="mat-override">
  <input
    matInput
    appDate
    placeholder="mm / dd / yyyy"
    autocomplete="off"
    [(ngModel)]="dateInputValue"
    (ngModelChange)="changeInputDate()"
    (blur)="onBlurInputDate()"
    #dateInput
    maxlength="10"
  />
  <input [matDatepicker]="picker" [(ngModel)]="date" class="hidden-input" (dateChange)="setDateInputValue()" />
  <mat-datepicker #picker></mat-datepicker>
  <mat-datepicker-toggle matSuffix (click)="clearAll()">
    <ion-icon matDatepickerToggleIcon name="close-outline"></ion-icon>
  </mat-datepicker-toggle>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
</mat-form-field>
